export { default } from 'modules/Seats/SeatBalances/SeatBalances'
